import { LookupItem } from "../../Shared/Models/LookupItem";

export class MedicalEducationModel {
    public physicianId: number;
    public medicalEducation : MedicalEducation;
    public medicalEducationLocationLookupList: Array<LookupItem>;
}

export class MedicalEducation {
    constructor() {
        this.isGraduationYearValid = true;
        this.isLocationIdValid = true;
    }
    public medicalEducationId: number;
    public physicianId: number;
    public graduationYear: number;
    public locationId: number;
    public isGraduationYearValid: boolean;
    public isLocationIdValid: boolean;
}

